/*
 * Copyright (c) 2025. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import * as z from 'zod';

export const transformedOptionalStringZod = z
  .string()
  .optional()
  .transform((v) => (v ? v.trim() : undefined));
